import { create } from 'zustand';

type AuthState = {
  isAuthenticated: boolean;
  accessToken: string | null;
  login: (token: string) => void;
  logout: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  accessToken: null,
  login: (token: string) => set({ isAuthenticated: true, accessToken: token }),
  logout: () => set({ isAuthenticated: false, accessToken: null }),
}));
